var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('p',[_vm._v(_vm._s(_vm.config.nothing))])])
}
var staticRenderFns = []

export { render, staticRenderFns }